module.exports = __webpack_public_path__ + "img/dsci0026.66ad2a73.jpg";